import {Routes, Route, useSearchParams} from "react-router-dom"

import {NotificationOfAssignmentAcknowledgement} from "./NotificationOfAssignmentAcknowledgement"

import {setRegionFromAWSRegion} from "@indebted/api"

function NotificationOfAssignmentAcknowledgementPage() {
	const [searchParams] = useSearchParams()
	const awsRegion = searchParams.get("region")
	setRegionFromAWSRegion(awsRegion!)

	return (
		<Routes>
			<Route element={<NotificationOfAssignmentAcknowledgement />} path="/" />
		</Routes>
	)
}

export {NotificationOfAssignmentAcknowledgementPage}
